import { render, staticRenderFns } from "./v-focus-mode.vue?vue&type=template&id=60159fe4&scoped=true&"
import script from "./v-focus-mode.vue?vue&type=script&lang=js&"
export * from "./v-focus-mode.vue?vue&type=script&lang=js&"
import style0 from "./v-focus-mode.vue?vue&type=style&index=0&id=60159fe4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60159fe4",
  null
  
)

export default component.exports